module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('el-row', [_c('div', {
    staticClass: "titles"
  }, [_c('span', {
    staticClass: "fonts"
  }, [_vm._v("毕业要求")])])]), _vm._v(" "), _c('el-form', {
    ref: "createdForm",
    staticClass: "small-space",
    attrs: {
      "model": _vm.createdForm,
      "label-position": "right",
      "label-width": "200px",
      "width": "100%",
      "inline": true
    }
  }, [_vm._l((_vm.courseAttr.length), function(index) {
    return _c('el-form-item', {
      key: index,
      staticClass: "form-item-font",
      attrs: {
        "label": _vm.courseAttr[index - 1].comboName + '学分',
        "prop": 'credit' + index
      }
    }, [_c('el-input-number', {
      style: ({
        width: _vm.inputWidth + 'px'
      }),
      attrs: {
        "disabled": _vm.editDisableState,
        "min": 0,
        "precision": 3,
        "step": 0.5,
        "label": '请输入' + _vm.courseAttr[index - 1].comboName + '学分'
      },
      model: {
        value: (_vm.createdForm['credit' + index]),
        callback: function($$v) {
          _vm.$set(_vm.createdForm, 'credit' + index, $$v)
        },
        expression: "createdForm['credit'+index]"
      }
    })], 1)
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "总学分",
      "prop": "totalCredit"
    }
  }, [_c('el-input-number', {
    style: ({
      width: _vm.inputWidth + 'px'
    }),
    attrs: {
      "disabled": _vm.editDisableState,
      "min": 0,
      "precision": 3,
      "step": 0.5,
      "placeholder": "请输入总学分要求"
    },
    model: {
      value: (_vm.createdForm.totalCredit),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "totalCredit", $$v)
      },
      expression: "createdForm.totalCredit"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item-font",
    attrs: {
      "label": "其他要求"
    }
  }, [_c('el-input', {
    style: ({
      width: _vm.textareaWidth + 'px'
    }),
    attrs: {
      "disabled": _vm.editDisableState,
      "type": "textarea",
      "autosize": {
        minRows: 5,
        maxRows: 5
      },
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.createdForm.otherRequire),
      callback: function($$v) {
        _vm.$set(_vm.createdForm, "otherRequire", $$v)
      },
      expression: "createdForm.otherRequire"
    }
  })], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-762edaa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/teachingScheme/graduateRequire.vue
// module id = 1866
// module chunks = 502